<template>
	<div class="container-fluid">
		<materials-tasks-toolbar title="Materials">

			<button v-if="hasModulePermWrite('Materials') || getUserRoleType() == 'Admin'" class="btn btn-success" v-on:click="priceModal.visible = true">
				<i class="fa fa-money-bill"></i>
				Bulk Pricing Update
			</button>
			
			<search-bar 
				placeholder="Search materials..." 
				v-on:submit="searchMaterials"
				v-on:clearSearch="clearSearch">
			</search-bar>

			<field style="margin-top: -5px;margin-right: 10px;" v-if="selectedCategory" :params="{type:'btn-group',buttons:[
				{text: 'All Categories',value:'all'},{text: selectedCategory.name,value:'this'}
			]}" v-model="searchScope"></field>

			<modal-dialog
				:modal-visible="priceModal.visible"
				title="Bulk Pricing Update"
				confirm-button-text="Upload"
				cancel-button-text="Done"
				v-on:confirm="uploadPricing"
				v-on:closeModal="priceModal.visible = false">

				<h3>Instructions</h3>

				<p>You can upload a .CSV file with new pricing values here. It should be a 5-column CSV file following the format shown below.</p>

				<p>The system will try to match by Supplier Part Number first, and then Part Number if Supplier Part Number is left blank.</p>

				<p>If you have multiple materials with matching part numbers from different suppliers or manufacturers, specify the supplier name and manufactur name in the 4th and 5th columns. If this is not a concern, you can leave them blank.</p>

				<p>If a product is matched by Part Number, but Supplier Part Number was included in the CSV file, the system will also populate the Supplier Part Number with the provided value, as well as update the pricing.</p>

				<p><strong>Note:</strong> There is a 1000 record limit per import file</p>


				<h4>Fields:</h4>

				<ul>
					<li>Supplier Part Number (optional if Part Number supplied)</li>
					<li>Part Number (optional if Supplier Part Number supplied)</li>
					<li>Trade Price in $</li>
					<li>Manufacturer (optional)</li>
					<li>Supplier (optional)</li>
				</ul>

				<p><strong>Example:</strong></p>

				<table class="spreadsheet-table mb-3">
					<tr>
						<th></th>
						<th>A</th>
						<th>B</th>
						<th>C</th>
						<th>D</th>
						<th>E</th>
					</tr>
					<tr>
						<th>1</th>
						<td>EMT-123</td>
						<td>EMT123</td>
						<td>89.93</td>
						<td>Acme</td>
						<td>Acme Distributions</td>
					</tr>
					<tr>
						<th>2</th>
						<td>EMT 90 ELL</td>
						<td>EMT90ELL</td>
						<td>56.12</td>
						<td></td>
						<td>Acme Distributions</td>
					</tr>
					<tr>
						<th>3</th>
						<td>CBLB-50COM</td>
						<td>CBLB50COM</td>
						<td>5.76</td>
						<td></td>
						<td></td>
					</tr>
				</table>

				<input type="file" class="form-control mb-2" v-on:change="setFile">

				<!--<form-group label="Pricing File (.csv)" col-class="col-md-4">
					<upload-field
						style-type="box"
						target="Material/upload-pricing"
						icon="fa-upload">
					</upload-field>
				</form-group>-->

			</modal-dialog>
			
		</materials-tasks-toolbar>

		<categorized-list-module
			record-name="Material"
			category-api-resource="MaterialCategory"
			record-api-resource="Material"
			num-records-field="num_materials"
			:list-fields="fields"
			:mutate-function="mutateMaterials"
			:import-columns="importColumns"
			:import-column-labels="importColumnLabels"
			:import-example-rows="importExampleRows"
			:searchable-fields="['description','part_number','supplier_number']"
			:search-terms="searchTerms"
			:fetch-trigger-toggle="fetchTriggerToggle"
			:search-scope="searchScope"
			:record-include="[
				{model: 'Contact',fields: ['id','slug','name']}
			]"
			v-on:editRecord="editMaterial"
			v-on:newRecord="newMaterial"
			v-on:categoryChange="categoryChange">
		</categorized-list-module>

		<material-edit-modal
			:title="editModal.title"
			:record="editModal.record"
			:visible="editModal.visible"
			:current-category="selectedCategory"
			v-on:closeModal="editModal.visible = false"
			v-on:modelChanged="triggerFetch">
		</material-edit-modal>
	</div>
</template>

<script type="text/javascript">
import MaterialsTasksToolbar from "./MaterialsTasksToolbar"

import CategorizedListModule from "@/components/super_components/CategorizedListModule"

import SearchBar from "../../components/SearchBar"
import Field from "../../components/Field"
import ModalDialog from "@/components/ModalDialog"
import UploadField from "@/components/UploadField"
import FormGroup from "@/components/FormGroup"

import MaterialEditModal from "../../components/super_components/MaterialEditModal"

export default {
	name: "MaterialsList",
	components: {
		MaterialsTasksToolbar,
		MaterialEditModal,
		Field,
		SearchBar,
		CategorizedListModule,
		ModalDialog,
		UploadField,
		FormGroup
	},
	data() {
		return {
			fields: [
				{label: "Part Number",key:"part_number"},
				{label: "Supplier PN",key:"supplier_number"},
				{label: "Description",key:"description"},
				{label: "Supplier",key:"supplierName"},
				{label: "Category", key: "parentCategoryName"},
				{label: "Trade Price", key: "material_price",align:"right"},
				{label: "Labour (hrs/unit)",key:'labour_hrs',align:'right'},
				{label: "Per",key: "per",align:'right'},
				{label: 'Unit',key:'material_unit_type'},
				{label: "Last Price Update",key:'priceUpdatedAt'}
			],
			importColumns: [
				"description",
				"part_number",
				"supplier_number",
				'supplierName',
				"price_updated",
				"per",
				"material_unit_type",
				"material_price",
				"labour_hrs",
				"manufacturer"
			],
			importColumnLabels: [
				"Description",
				"Part Number",
				"Supplier Part Number",
				'Supplier',
				"Date of Last Price Update",
				"Per Unit (1, 100, 1000)",
				"Unit Type (each, ft, m, yard, oz, lb, ton, g, kg, sq.ft., sq.m., sq.yd, lt, usg)",
				"Material Price",
				"Labour (hrs/unit) (up to 3 decimal places)",
				"Manufacturer"
			],
			importExampleRows: [
				["A","B","C","D","E","F","G","H","I","J"],
				['1/2" EMT Conduit','EMT-123','EMT123','ACME Supplies','2018-01-02','100','ft','89.93','0.750','ACME'],
				['EMT Elbow','EMT 90 ELL','EMT90ELL','ACME Supplies','2018-01-02','100','m','56.12','1.405','ACME'],
				['1/2" Conduit Body','CBLB-50COM','CBLB50COM','ACME Supplies','2018-01-02','1','each','5.76','0.050','ACME']
			],
			editModal: {
				visible: false,
				title: "",
				record: {}
			},
			searchTerms: "",
			selectedCategory: null,
			fetchTriggerToggle: false,
			searchScope: "",
			priceModal: {
				visible: false,
				file: null
			}
		}
	},
	methods: {
		mutateMaterials(mats) {
			let vm = this

			return mats.map(mat => {
				mat.parentCategoryName = mat.MaterialCategory.name
				mat.updatedAt = vm.formatDateTimeToLocal(mat.updated_at)

				mat.supplierName = ""
				if ("Supplier" in mat && mat.Supplier)
					mat.supplierName = mat.Supplier.name

				mat.priceUpdatedAt = mat.price_updated != '0000-00-00' && mat.price_updated != null ?
					vm.formatDate(mat.price_updated) : vm.formatDate(mat.created_at)

				return mat
			})
		},
		setFile(evt) {
			if (evt.target.files.length > 0)
				this.priceModal.file = evt.target.files[0]
		},
		uploadPricing() {
			let vm = this

			let f = this.priceModal.file;

			let reader = new FileReader();

			let fileValid = true

			let allowedMimes = [
				"text/plain",
				"text/csv",
				"application/vnd.ms-excel"
			]

			//check file extension type
			if (allowedMimes.indexOf(f.type) == -1)
				vm.alertFail("Invalid file format! File must be a CSV")

			else {

				 // Closure to capture the file information.
				reader.onload = (theFile => {
					return e => {
						
						let csvObj = vm.CSVToArray(e.target.result)

						//check if last row is a blank, if so remove it
						if (csvObj[csvObj.length-1].length == 1)
							csvObj.splice(csvObj.length-1,1)

						let recordsPayload, resource, numFields

						numFields = 5

						//check appropriate number of fields per row
						csvObj.forEach(row => {
							if (row.length > numFields)
								fileValid = false
						})

						recordsPayload = csvObj.map(row => {
							let obj = {
								supplier_number: row[0],
								part_number: row[1],
								material_price: row[2],
							}

							if (row.length > 3)
								obj.manufacturer = row[3]
							if (row.length > 4)
								obj.supplierName = row[4]

							return obj
						})
						
						if (fileValid) {
							vm.spinner(true)

							vm.postData("Material/update-pricing",{records: JSON.stringify(recordsPayload)}).then(response => {
								vm.alertSaved(response.data.records_saved+" Prices updated successfully!")
								vm.spinner(false)

								vm.priceModal.visible = false
							})
						}
						else 
							vm.alertFail("Invalid CSV format! There must be "+numFields+" fields per row or less.")
						
					};
				})(f);

				reader.readAsText(f);
			}
		},
		newMaterial(cat_id) {
			this.editModal.visible = true
			this.editModal.title = "New Material"
			this.editModal.record = {
				category_id: cat_id,
				description: "",
				part_number: "",
				supplier_number: "",
				manufacturer: "",
				per: 1,
				material_unit_type: 1,
			}
		},
		editMaterial(material) {
			this.editModal.visible = true
			this.editModal.title = "Edit Material"
			this.editModal.record = JSON.parse(JSON.stringify(material))
		},
		triggerFetch() {
			this.editModal.visible = false
			this.fetchTriggerToggle = !this.fetchTriggerToggle
		},
		searchMaterials(terms) {
			this.searchTerms = ""
			this.$nextTick(() => {
				this.searchTerms = terms
			})
		},
		clearSearch() {
			this.searchTerms = ""
		},
		categoryChange(cat) {
			this.selectedCategory = cat
		}
	}
}
</script>